<nav class="ui-sidebar-main">
  <div class="nav-content">
    <ng-content select="[sidebar-header]"></ng-content>
    <!-- <ng-content select="[sidebar-before]"></ng-content> -->
    <hr class="separator" />
    <ng-content select="[sidebar-content]"></ng-content>
  </div>
</nav>

